import classes from "./contact-item.module.css";

type ContactItemProps = {
	icon: string;
	texts: string[];
	href?: string;
	onClick?: () => void;
};

export const ContactItem = ({
	icon,
	texts,
	href,
	onClick,
}: ContactItemProps) => {
	return (
		<a className={classes.item} href={href} onClick={onClick}>
			<img className={classes.icon} src={icon} alt={texts.join(", ")} />
			<div className={classes.text}>
				{texts.map((text, index) => (
					<p key={index}>{text}</p>
				))}
			</div>
		</a>
	);
};
